<template>
  <div class="w-100 admin-page">
    <admin-edit-user-modal
      :modalId="'adminEditUser'"
      @userUpdated="onUserUpdated"
    ></admin-edit-user-modal>
    <add-user-modal
      :modalId="'adminAddUser'"
      @userAdded="onUserAdded"
    ></add-user-modal>
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="admin-search-bar">
            <div>
              <form class="w-100">
                <div class="row">
                  <div class="col-12 col-sm-10 my-1">
                    <input
                      type="search"
                      class="form-control form-control-sm"
                      placeholder="Ge mig något att jobba med..."
                      v-model="filters.text"
                    />
                  </div>
                  <div class="col-12 col-sm-2">
                    <button
                      type="submit"
                      class="btn btn-secondary btn-sm w-100 my-1"
                      @click.prevent="onSearch"
                    >
                      Sök
                    </button>
                  </div>
                </div>
              </form>
              <div class="row mt-2">
                <div class="col-12">
                  <button
                    class="btn btn-primary btn-sm w-100 my-1"
                    @click="onAddUser"
                  >
                    Ny anändare
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div
      v-if="isWideView"
      :class="[
        isWideView ? 'text-center' : 'text-left',
        'row',
        'user-row',
        'profile-data-header',
      ]"
    >
      <div :class="['col-3', { 'text-left': isWideView }]">Namn</div>
      <div :class="['col-3', { 'text-left': isWideView }]">Email</div>
      <div class="col-2">Status</div>
      <div class="col-3">Receptbanker</div>
      <div class="col-1"></div>
      <div class="col-12 p-0 list-header-divider"></div>
    </div>
    <div
      v-for="user in users"
      :key="user.email"
      :class="[isWideView ? 'text-center' : 'text-left', 'row', 'user-row']"
    >
      <div
        :class="[
          'col-12',
          'col-sm-3',
          'admin-list-cell',
          { 'text-left': isWideView },
          { 'font-weight-bold': !isWideView },
        ]"
      >
        {{ user.name }}
      </div>
      <div
        :class="[
          'col-12',
          'col-sm-3',
          'admin-list-cell',
          { 'text-left': isWideView },
        ]"
      >
        {{ user.email }}
      </div>
      <div
        :class="[
          'col-12',
          'col-sm-2',
          'admin-list-cell',
          { 'status-limited-width': !isWideView },
        ]"
      >
        <b-badge v-if="user.activated" variant="success">Aktiverad</b-badge>
        <b-badge v-else variant="warning">Ej aktiverad</b-badge>
      </div>
      <div v-if="isWideView" class="col-12 col-sm-3 admin-list-cell">
        {{ user.recipeBankCount }}
      </div>
      <div v-else class="col-12 col-sm-3 admin-list-cell">
        {{ user.recipeBankCount }} receptbanker
      </div>
      <div
        :class="[
          'col-12',
          'col-sm-1',
          'admin-list-cell',
          { adjusted: isWideView },
        ]"
      >
        <b-dropdown
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          droprigth
          :no-caret="isWideView"
          :text="'Hantera'"
        >
          <template v-if="isWideView" #button-content>
            <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
          </template>
          <b-dropdown-item @click="onUserEdit(user)">Redigera</b-dropdown-item>
          <b-dropdown-item
            v-if="!user.activated"
            @click="onSendActivationLink(user)"
            >Skicka aktiveringslänk</b-dropdown-item
          >
          <b-dropdown-item v-else @click="onSendPasswordReset(user)"
            >Återställ lösenord</b-dropdown-item
          >
          <b-dropdown-item @click="onDeleteUser(user)" class="text-danger"
            >Ta bort</b-dropdown-item
          >
        </b-dropdown>
      </div>
      <div class="col-12 p-0"><hr /></div>
    </div>
    <div class="overflow-auto pagination-nav-container">
      <b-pagination
        v-model="filters.page"
        :total-rows="totalCount"
        :per-page="filters.pageSize"
        first-number
        last-number
        @change="onPaginate"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service.js";
import AdminEditUserModal from "../modals/admin-edit-user-modal.vue";
import AddUserModal from "../modals/add-user-modal.vue";
const defaultPageSize = 30;
const sort = "name";

export default {
  components: {
    AdminEditUserModal,
    AddUserModal,
  },
  data: function () {
    return {
      filters: {},
    };
  },
  computed: {
    totalCount: function () {
      return this.$store.state.users.metadata.total_records;
    },
    users: function () {
      return this.$store.state.users.users;
    },
    isWideView: function () {
      return this.$store.getters["isWideView"];
    },
  },
  methods: {
    defaultFilters: function () {
      return {
        page: 1,
        pageSize: defaultPageSize,
        text: "",
        sort: sort,
      };
    },
    onAddUser: function () {
      this.$bvModal.show("adminAddUser");
    },
    onUserUpdated: function () {
      this.search(this.filters);
    },
    onUserAdded: function () {
      this.search(this.filters);
    },
    search: function (filters) {
      this.$store.dispatch("users/search", { filters: filters });
    },
    onPaginate: function (index) {
      this.search({ ...this.filters, page: index });
    },
    onSearch: function () {
      this.filters = { ...this.defaultFilters(), text: this.filters.text };
      this.search(this.filters);
    },
    onUserEdit: function (user) {
      this.$bus.dispatch("showAdminEditUserModal", { user });
    },
    onSendActivationLink: function (user) {
      UserService.sendActivationLink(user.email)
        .then(() => {
          this.$bus.dispatch("showToastSuccess", {
            title: "Aktiveringslänk skickad",
            message: `Begäran att skicka en aktiveringslänk till användare '${user.email}' hanterades framgångsrikt`,
          });
        })
        .catch((e) => {
          console.log(e);
          this.$bus.dispatch("showToastFailure", {
            title: "Aktiveringslänk kunde inte skickas",
            message: `'Oops! Något gick fel. Kolla i loggarna för mer information`,
          });
        });
    },
    onSendPasswordReset: function (user) {
      UserService.sendPasswordResetLink(user.email)
        .then(() => {
          this.$bus.dispatch("showToastSuccess", {
            title: "Återställning av lösenord skickad",
            message: `Begäran att skicka en länk för återställning av lösenord till användare '${user.email}' hanterades framgångsrikt`,
          });
        })
        .catch((e) => {
          console.log(e);
          this.$bus.dispatch("showToastFailure", {
            title: "Återställning av lösenord kunde inte skickas",
            message: `'Oops! Något gick fel. Kolla i loggarna för mer information`,
          });
        });
    },
    onDeleteUser: function (user) {
      this.$bvModal
        .msgBoxConfirm(
          `Är du säkert på att du vill ta bort användaren '${user.email}'?`,
          {
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Ta bort",
            cancelTitle: "Avbryt",
          }
        )
        .then((result) => {
          if (result) {
            return UserService.deleteUserById(user.id).then(() => {
              this.search(this.filters);
            });
          }
          return Promise.resolve();
        })
        .catch((e) => {
          console.log(e);
          this.$bus.dispatch("showToastFailure", {
            title: "Användare kunde inte tas bort",
            message: `Oops! Något gick fel när användare '${user.email}' skulle tas bort. Kolla i loggarna för mer information`,
          });
        });
    },
  },
  mounted() {
    this.filters = this.defaultFilters();
    this.search(this.filters);
  },
};
</script>

<style scoped>
.status-limited-width {
  max-width: 150px;
}

.dropdown >>> button {
  text-align: left;
  border: none;
  padding: 0.5rem 0 0 0;
}

.dropdown >>> button:focus,
.dropdown >>> button:focus-visible {
  outline: none;
  box-shadow: none;
}

.adjusted {
  margin-top: -0.5rem;
}
</style>